import { render, staticRenderFns } from "./EditorComponent.vue?vue&type=template&id=12ed6a3d&scoped=true&"
import script from "./EditorComponent.vue?vue&type=script&lang=js&"
export * from "./EditorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed6a3d",
  null
  
)

export default component.exports